import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Button,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  GridViewRounded,
  EqualizerRounded,
  CalendarMonthRounded,
  ExpandMoreRounded,
} from "@mui/icons-material";
import { useEffect, useMemo, useState } from "react";
import AgentHeaderCard from "./HeaderCard";
import CommonFilter from "../../../components/CommonFilter";
import { Paper, Tabs, Tab } from "@mui/material";
import {
  InsertChartOutlinedRounded as OverviewIcon,
  TrackChangesRounded as ScorecardIcon,
  AutoAwesomeRounded as AiIcon,
} from "@mui/icons-material";
import Overview from "./overview";
import ScoreCard from "./scorecard";
import AiInsight from "./aiinsights";
import axiosInstance from "../../../services/axiosInterceptors";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import { useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useSearchParams } from "react-router-dom";
import { palette, theme as colorTheme } from "../../../Convoze.theme";
import { Surface } from "recharts";
import ParentWrapper from "../../../components/ParentWrapper";
import Header from "../../../components/header";

const colors = {
  // bg: "#0b0b0f",
  bg : colorTheme('palette', 'night').value,
  // surface: "#0f1014",
  surface: colorTheme('palette', 'night').value,
  text: "#e5e7eb",
  // subtext: "#9aa0a6",
  subtext:colorTheme('palette', 'secondary').value,
  // border: "#1f1f23",
  border : colorTheme('palette', 'night').value,
  // purple: "#a78bfa",
  purple : colorTheme('palette', 'primary').value
};

function a11yProps(index) {
  return {
    id: `pill-tab-${index}`,
    "aria-controls": `pill-tabpanel-${index}`,
  };
}
function TabPanel({
  children,
  value,
  index,
  disablePadding = false,
  sx = {},
  contentSx = {},
}) {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`pill-tabpanel-${index}`}
      aria-labelledby={`pill-tab-${index}`}
      sx={{ mt: 0, ...sx }}
    >
      {value === index && (
        <Box sx={{ p: disablePadding ? 0 : { xs: 1.5, sm: 2 }, ...contentSx }}>
          {children}
        </Box>
      )}
    </Box>
  );
}


export default function AgentProfile() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const avatar = searchParams.get("avatar");
  const agentName = (searchParams.get("agentName") || "John Doe").trim();
  const token = localStorage.getItem("token");
  const isFilter = { date: true, filter: false };
  const [payloadData, setPayloadData] = useState();
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));
  const [agentProfileData, setAgentProfileData] = useState();
  const [agentKpisData, setAgentKpisData] = useState();
  const [loading, setLoading] = useState(true);
  const handleChange = (_e, newValue) => setValue(newValue);
  const lastUpdated = useMemo(() => {
    const decodedToken = token ? jwtDecode(token) : "";
    console.log(decodedToken, "fff");
    const d = new Date();
    return d.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }, []);

  useEffect(() => {
    const today = new Date();
    const data = {
      startDate: payloadData?.filters?.startDate
        ? payloadData?.filters?.startDate
        : today?.toISOString().split("T")[0],
      endDate: payloadData?.filters?.endDate
        ? payloadData?.filters?.endDate
        : today?.toISOString().split("T")[0],
      agentId: id || "",
    };
    fetchAgentProfileDetails(data);
    fetchKpisDetails(data);
  }, [payloadData]);

  const fetchAgentProfileDetails = async (data) => {
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.agentProfile,
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setAgentProfileData(res?.data?.data);
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Dashboard fetch error:", error);
      }
    }
  };
  const fetchKpisDetails = async (data) => {
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.agentKpis,
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setAgentKpisData(res?.data?.data);
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Dashboard fetch error:", error);
      }
    }
  };
  return (
   
      <ParentWrapper>
         {/* Top bar */}
      <AppBar
        position="static"
        elevation={0}
        sx={{
          bgcolor: "#FFFFFF",
          // borderBottom: `0.5px solid #D2D2D2`,
        }}
      >
        <Toolbar
          sx={{
            minHeight: 64,
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 1.25 }}>
            {/* <svg
              style={{ color: "#6366F1" }}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-chart-column w-6 h-6 text-primary"
              data-lov-id="src/pages/Index.tsx:287:14"
              data-lov-name="BarChart3"
              data-component-path="src/pages/Index.tsx"
              data-component-line="287"
              data-component-file="Index.tsx"
              data-component-name="BarChart3"
              data-component-content="%7B%22className%22%3A%22w-6%20h-6%20text-primary%22%7D"
            >
              <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
              <path d="M18 17V9"></path>
              <path d="M13 17V5"></path>
              <path d="M8 17v-3"></path>
            </svg> */}
            {/* 
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontSize: "1.25rem", color: "#424242" }}
            >
              Agent Dashboard
            </Typography>
              
             <Typography
              variant="body2"
              sx={{ fontWeight: 400, fontSize: "1.25rem",color:"gray" }}
            >
              Dive deep into agent performance analytics.
            </Typography> */}

            <Box>
              {/* <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontSize: "1.25rem", color: "#424242" }}
              >
                Agent Dashboard
              </Typography>

              <Typography
                variant="body2"
                sx={{ fontWeight: 400, fontSize: "1rem", color: "grey" }}
              >
                Dive deep into agent performance analytics.
              </Typography> */}
                {/* <Header title={"Agent Dashboard"} subHeading={"Dive deep into agent performance analytics."} /> */}
            </Box>
          </Box>

          <Box
            sx={{width:"100%", display: "flex", justifyContent:"flex-end", alignItems: "center", gap: 3 }}
          >
            <CommonFilter setPayloadData={setPayloadData} isFilter={isFilter} />
          </Box>

          
        </Toolbar>
      </AppBar>

      {/* Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <AgentHeaderCard avatar={avatar} agentName={agentName} />
        <Paper
          elevation={0}
          sx={{
            border: `1px solid #D2D2D2`,
            borderRadius: 2,
            px: { xs: 0.5, sm: 0.75 },
            py: { xs: 0.5, sm: 0.6 },
            overflow: "hidden",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            TabIndicatorProps={{ style: { display: "none" } }}
            aria-label="Agent section tabs"
            sx={{
              minHeight: 0,
              "& .MuiTabs-flexContainer": {
                gap: { xs: 0.5, sm: 0.75 },
              },
            }}
          >
            <Tab
              icon={<OverviewIcon sx={{ fontSize: 18 }} />}
              iconPosition="start"
              label={
                <Typography sx={{ fontWeight: 600, fontSize: "0.75rem" }}>
                  Overview
                </Typography>
              }
              disableRipple
              {...a11yProps(0)}
              sx={{
                minHeight: "22px !important",
                py: 0.5,
                px: 2,
                borderRadius: 5,
                textTransform: "none",
                fontSize: { xs: 12, sm: 13 },
                fontWeight: 700,
                transition: "all 200ms ease",
                "&.Mui-selected": {
                  minHeight: "22px !important",
                  color: "#fff",
                  // background: `linear-gradient(90deg, #6366F1 0%, #6366F1 100%)`,
                  background : colorTheme('palette', 'primary').value,
                  boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.08)",
                  borderRadius: 3,
                },
              }}
            />

            <Tab
              icon={<ScorecardIcon sx={{ fontSize: 18 }} />}
              iconPosition="start"
              label={
                <Typography sx={{ fontWeight: 600, fontSize: "0.75rem" }}>
                  Scorecard
                </Typography>
              }
              disableRipple
              {...a11yProps(1)}
              sx={{
                minHeight: "22px !important",
                py: 0.5,
                px: 2,
                borderRadius: 5,
                textTransform: "none",
                fontSize: { xs: 12, sm: 13 },
                transition: "all 200ms ease",
                "&.Mui-selected": {
                  minHeight: "22px !important",
                  color: "#fff",
                  // background: `linear-gradient(90deg, #6366F1 0%, #6366F1 100%)`,
                  background : colorTheme('palette', 'primary').value,
                  boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.08)",
                  borderRadius: 3,
                },
              }}
            />

            <Tab
              icon={<AiIcon sx={{ fontSize: 18 }} />}
              iconPosition="start"
              disableRipple
              {...a11yProps(2)}
              label={
                <Typography sx={{ fontWeight: 600, fontSize: "0.75rem" }}>
                  AI Insights
                </Typography>
              }
              sx={{
                minHeight: "22px !important",
                py: 0.5,
                px: 2,
                borderRadius: 5,
                textTransform: "none",
                fontSize: { xs: 12, sm: 13 },
                "&.Mui-selected": {
                  minHeight: "22px !important",
                  color: "#fff",
                  // background: `linear-gradient(90deg, #6366F1 0%, #6366F1 100%)`,
                  background : colorTheme('palette', 'primary').value,
                  boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.08)",
                  borderRadius: 3,
                },
              }}
            />
          </Tabs>
        </Paper>
        <TabPanel value={value} index={0} disablePadding>
          <Overview
            agentKpisData={agentKpisData}
            agentProfileData={agentProfileData}
          />
        </TabPanel>
        <TabPanel value={value} index={1} disablePadding>
          <ScoreCard agentKpisData={agentKpisData} />
        </TabPanel>
        <TabPanel value={value} index={2} disablePadding>
          <AiInsight
            agentKpisData={agentKpisData}
            agentProfileData={agentProfileData}
          />
        </TabPanel>
      </Box>

      </ParentWrapper>
    // </Box>
  );
}
